// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import NavBar from './NavBar';
import Menu from '../Menu';
import { Link, useLocation } from 'react-router-dom';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import MobileTitle from '../MobileTitle';
import Bubbles from '../../_common/Bubbles';
import History from './History';
import InstallerPrompt from '../InstallerPrompt';
import OfflineAlert from '../OfflineAlert';
import UpdateAlert from '../UpdateAlert';

const Wrapper = styled.div`
    /*height: calc(var(--100vvh, 100vh));*/
    /*width: calc(var(--100vvw, 100vw));*/
    
    height: ${({ height }) => height}px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow: hidden !important;
    box-shadow: ${({ showPWAShadow }) => showPWAShadow ? 'inset 0px 0px 20px 3px #00000070' : 'unset'};

    ${({ theme, image }) => image ? (`
    background-image: url(${image});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    `) : `background: ${theme.mobile.body};`}
`
const ContentWrapper = styled.main`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    align-items: stretch;
    overflow: auto;
    scrollbar-gutter: ${({ showGutter }) => showGutter ? 'stable' : 'unset'};

    overflow-x: hidden;
    position: relative;
    z-index: 5;

    overscroll-behavior: contain;
`
const ImgWrapper = styled(Link)`
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.5s;
    box-shadow: unset;
    position: relative;
    z-index: ${({ current, signup }) => current ? 3 : !signup ? 6 : 3};
`
const NoLinkWrapper = styled.main`
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.5s;
    box-shadow: unset;
    position: relative;
`
const Img = styled.img`
    width: ${({ current, checkout }) => current ? '75%' : checkout ? '55%' : '30%'};
    transition: all 0.3s;
    z-index: ${({ current }) => current ? 3 : 6};
    max-height: 20vh;
    margin: 0.2em;
    margin-top: ${({ login }) => login ? '10vh;' : '0'};
`
const BackCard = styled.div`
    background: ${({ theme }) => theme.mobile.primary};
    position: absolute;
    width: 100%;
    transition: all 0.5s;
    height: ${({ current, login }) => login ? '100vh' : current ? '150%' : '100%'};
    z-index: 1;
`

const Layout = ({ children, ...props }) => {
    const {
        state: {
            active_user,
            site_config
        },
        getUnreadNotifications
    } = useGlobalState();

    const current = (window.location.pathname === '/')
    const checkout = (window.location.pathname === '/checkout' || window.location.pathname === '/passwordRecovery')

    const theme = useTheme();
    document.getElementById('themeColor').content = theme.mobile.primary;

    const [height, setHeight] = useState(window.innerHeight);
    useLayoutEffect(() => {
        const updateWidth = () => setHeight(window.innerHeight)
        window.addEventListener('resize', updateWidth);
        return () => window.removeEventListener('resize', updateWidth);
    });

    useEffect(() => {
        const stopRotation = () => setHeight(window.innerHeight)
        window.addEventListener('orientationchange', stopRotation);
        return () => window.removeEventListener('orientationchange', stopRotation);
    });

    const [scrollHeight, setScrollHeight] = useState(0)
    const checkHeight = e => setScrollHeight(e.target.scrollTop)

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (active_user.isLoggedIn) getUnreadNotifications()
        }, 120000)
        return () => clearInterval(intervalId);
    }, [active_user.isLoggedIn])

    const [isOpen, setIsOpen] = useState(false);


    const [hasOverflown, setHasOverflown] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        setHasOverflown(false);
        const content = contentRef.current;
        if (!content) return;
        const resizeObserver = new ResizeObserver(entries => {
            const { clientHeight, scrollHeight } = entries[0].target;
            if (!hasOverflown && scrollHeight > clientHeight) {
                setHasOverflown(true);
            }
        });
        resizeObserver.observe(content);
        return () => resizeObserver.disconnect();
    }, [window.location.pathname])

    function IsUpdated() {
        const pathname = window.location.pathname;
        return  (pathname === '/Updated' || pathname === '/passwordRecovery') ? true : false;        
    }

    return (
        <Wrapper
            height={height}
            showPWAShadow={site_config.showPWAShadow}
            image={site_config.PWAHomeImage}
        >
            <OfflineAlert />
            <UpdateAlert />
            {/* <InstallerPrompt /> */}
            {site_config.bubbles.enabled ? <Bubbles /> : null}
            {(active_user.isLoggedIn || active_user.isGuestUser) && <Menu isOpen={isOpen} setIsOpen={setIsOpen} />}
            {IsUpdated() ?
            <NoLinkWrapper scrolled={scrollHeight} signup={window.location.pathname === '/signUp' ? 1 : 0}>
            <Img
                src={site_config.logo}
                current={current ? 1 : 0}
                checkout={checkout ? 1 : 0}
                login={current && (!active_user.isLoggedIn && !active_user.isGuestUser)}
                alt='logo'
            />
            <BackCard
                    current={current ? 1 : 0}
                    scrolled={scrollHeight}
                    login={(current && (!active_user.isLoggedIn && !active_user.isGuestUser)) || (window.location.pathname === '/signUp')}
                />
            </NoLinkWrapper>
            :
            <ImgWrapper to = '/' current={current ? 1 : 0} scrolled={scrollHeight} signup={window.location.pathname === '/signUp' ? 1 : 0}>
                <Img
                    src={site_config.logo}
                    current={current ? 1 : 0}
                    checkout={checkout ? 1 : 0}
                    login={current && (!active_user.isLoggedIn && !active_user.isGuestUser)}
                    alt='logo'
                />
                <BackCard
                    current={current ? 1 : 0}
                    scrolled={scrollHeight}
                    login={(current && (!active_user.isLoggedIn && !active_user.isGuestUser)) || (window.location.pathname === '/signUp')}
                />
            </ImgWrapper>
            
}
            <ContentWrapper
                id='content_wrapper'
                onScroll={checkHeight}
                ref={contentRef}
                showGutter={hasOverflown}
            >
                {children}
            </ContentWrapper>
            <History />            
            {(active_user.isLoggedIn || active_user.isGuestUser && !IsUpdated() ) && <NavBar isOpen={isOpen} setIsOpen={setIsOpen} />}
        </Wrapper>
    );
}

export default Layout;